var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('HeaderBar'),_c('div',{attrs:{"id":"main"}},[_c('BannerBar',{attrs:{"label":"关于我们"}}),_c('CompanyIntroContent'),_c('TeamIntroContent')],1),_c('FooterBar'),_c('scroll-back')],1)}
var staticRenderFns = []

export { render, staticRenderFns }